<template>
  <v-container fluid class="container-class">
        <notifications group="userLogin" position="bottom right" style="direction:rtl"/>
        <div class="loginFormHolder">
            <div class="left-section">
                <div class="left-section-logo">
                    <v-img class="left-section-img" contain width="40%" :src="require('../assets/logo.png')"></v-img>
                </div>
                
                <div class="left-section-form-content-holder">
                    
                    <v-tabs vertical style="direction:ltr">
                        <v-tab>
                            ورود
                        </v-tab>
                        <v-tab>
                            پشتیبانی
                        </v-tab>
                        <v-tab-item>
                            <v-layout row wrap style="direction:rtl !important;">
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <div class="left-section-form-logo">
                                        ورود
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <v-text-field style="direction:ltr" v-model="username" single-line color="baseColor" placeholder="نام کاربری">
                                        <template v-slot:prepend-inner>
                                            <v-icon style="padding-right:10px;" small>fas fa-user</v-icon>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <v-text-field style="direction:ltr" v-model="password" :type="showPwd ? 'text' : 'password'"  single-line color="baseColor" placeholder="رمز عبور">
                                        <template v-slot:prepend-inner>
                                            <v-icon style="padding-right:10px;" small @click="showPwd = false" v-if="showPwd">fas fa-eye</v-icon>
                                            <v-icon style="padding-right:10px;" small @click="showPwd = true" v-if="!showPwd">fas fa-eye-slash</v-icon>
                                        </template>
                                        <template v-slot:append>
                                            <a class="inner-textfield-link" href="javascript:void(0);">فراموشی رمز  </a>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <v-btn @click="login" :loading="inLogining" color="baseColor" dark rounded block>ورود</v-btn>
                                </v-flex>
                                <v-flex xs12 sm12 md12 lg12 xl12 style="padding-top:15px;">
                                    <v-checkbox color="baseColor" label="مرا بخاطر بسپار"></v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-tab-item>
                        <v-tab-item>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12 lg12 xl12 style="display:block;height:80%">
                                    <v-img :src="require('../assets/support.jpg')"></v-img>
                                </v-flex>
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <br/><br/><br/><br/>
                                    <v-btn href="http://help.barayand.net/login" target="_blank" dark rounded color="baseColor" block>
                                        ورود به سامانه پشتیبانی
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-tab-item>
                    </v-tabs>
                </div>
            </div>
            <div class="right-section-holder" >
                <v-img contain class="human-image" height="60%" width="200px" :src="require('../assets/human.png')"></v-img>
                <div class="right-section-ads-holder">
                    سامانه جامع مدیریت محتوی  آسانا 
                    <v-btn style="display:block;margin:auto;margin-top:5% !important;display:flex;align-items:center;" width="200" color="#fff" href="http://barayand.net" outlined>بیشتر <v-icon style="display:inline-block;margin-right:20px" small>fas fa-chevron-left</v-icon></v-btn>
                </div>            
            </div>
        </div>
    </v-container>
</template>
<script>
const ApiUrl = require("../constant/apiurl");
const MSGHNDL = require("../constant/MessageHandler");
import { mapState, mapMutations, mapActions } from 'vuex'
const axios = require('axios');
export default {
    name:"login",
    data:()=>({
        uname:"",
        pwd:"",
        wait:false,
        username:'',
        password:'',
        showPwd:false,
        inLogining:false
    }),
     mounted: function() {
    var vm = this;
    vm.checkIsLoginRoute();
    window.addEventListener("load", function(event) {
      vm.checkIsLoginRoute();
    });
  },
    methods:{
        checkIsLoginRoute() {
      var vm =this;
      if (this.$route.name == "login") {
        this.isLoginPage = true;
      } else {
        this.isLoginPage = false;
        vm.userData = vm.$store.getters.userData;
      }
    },
        ...mapActions([                  // Add this
        'SetLogin'
        ]),
        async login()
        {
            let vm = this;
            if(vm.username == "" || vm.username == null)
            {
                MSGHNDL.ERR("نام کاربری الزامی است");
                return;
            }
            if(vm.password == "" || vm.password == null)
            {
                MSGHNDL.ERR("رمز عبور الزامی است");
                return;
            }
            vm.inLogining = true;
            // window.localStorage.setItem("LoggedIn",true);
            // this.$router.push('/');
            var Model = {};
            Model.U_Email = vm.username;
            Model.U_Password = vm.password;
            vm.wait = true;
            await axios.post(ApiUrl.SysUserLogin,Model).then((result) => {
                var res = result.data;
                vm.inLogining = false;
                if(res.status)
                {
                    MSGHNDL.OK(res.msg);
                    
                    console.warn("Login Result : ",res.data);
                    vm.SetLogin(res.data);
                    setTimeout(() => {
                        if(res.data.perms.length > 0)
                        {
                            var i = "";
                            vm.$router.options.routes.forEach(el => {
                                if(el.name != 'login' && el.meta.id == res.data.perms[0])
                                {
                                    i = el.path;
                                }
                                });
                            // vm.$router.push(i);
                            window.location.href = i;
                        }
                        else
                        {
                            // vm.$router.push('/');
                            window.location.href = "/";
                        }
                    }, 1000);
                }
                else
                {
                    MSGHNDL.ERR(res.msg);
                }
            }).catch((err) => {
                vm.inLogining = false;
                console.error(err);
            });
        }
    }
}
</script>
<style >
.container-class .v-slide-group
{
    position: absolute !important;
}
.container-class .v-tabs-slider
{
    background-color: transparent !important;
} 
.container-class .v-tab
{
    background: transparent;
    color:#fff !important;
}
.container-class .v-tab--active
{
    background: #fff;
    color: rgb(0,0,0) !important;
    box-shadow: 2px 0px 4px rgba(0,0,0,0.5);
}
.container-class .v-tab--active,.container-class .v-tab {
 
    border-right-color: #fff !important;
    height: 40px !important;
    border-bottom-left-radius: 15px;
    border-top-left-radius: 15px;
}
.container-class .v-slide-group__wrapper {
    contain: content;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    overflow: hidden;
    position: relative;
    left: -133%;
    top: -115px;
    z-index: 1111111111;
}
</style>
<style scoped>
.right-section-ads-holder
{
    width:70%;
    height: 80%;
    position: absolute;
    left: 2%;
    top:10%;
    font-size: 2vw;
    text-align: center;
    color: #fff;
    font-weight: lighter;
    padding-top: 20%;
    box-sizing: border-box;
}
.human-image
{
    width: inherit;
    position: absolute;
    bottom: 0px;
    right: 0%;
}
html
{
    overflow: hidden !important;
}
.container-class
{
/* background: rgb(166,37,1);
background: linear-gradient(25deg, rgba(166,37,1,1) 0%, rgba(238,78,34,1) 46%, rgba(245,82,37,1) 69%, rgba(250,107,68,1) 100%);*/
    height: 100%; 
    width:100%;
    display: block;
    position: relative;
        background: rgb(198,50,9);
    background: linear-gradient(25deg, rgba(198,50,9,1) 0%, rgba(244,107,69,1) 46%, rgba(245,110,72,1) 69%, rgba(249,122,87,1) 100%);

}
.loginFormHolder
{
    display: block;
    width: 80%;
    height: 80%;
    position: relative;
    margin: auto;
    top: 10%;
    box-shadow: 0px 0px 40px rgba(0,0,0,0.5);
    background: rgb(198,50,9);
    background: linear-gradient(25deg, rgba(198,50,9,1) 0%, rgba(244,107,69,1) 46%, rgba(245,110,72,1) 69%, rgba(249,122,87,1) 100%);
}
.right-section-holder
{
    position: absolute;
    left:0px;
    top: 0px;
    height: 100%;
    width: 70%;
    background:rgba(110, 96, 96, 0);
}
@media only screen 
  and (min-device-width: 320px) 
  and (max-device-width: 680px)
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: portrait) {
      .left-section
        {
            width: 100% !important;
        }
       .v-tabs--vertical > .v-tabs-bar .v-tab, .right-section-holder
        {
            display: none !important;
        }
        .loginFormHolder
        {
            height: 51% !important;
            top: 24% !important;
        }
        
}
.left-section
{
    position: absolute;
    right:0px;
    top: 0px;
    height: 100%;
    width: 30%;
    background:#fff;
    box-shadow: 0px 0px 2px rgba(0,0,0,0.5);
}
.left-section-img
{
        position: absolute;
    right: 31%;
    top: 2%;
    display: block;
}
.left-section-form-content-holder
{
    width: 100%;
    height: 80%;
    display: block;
    position: absolute;
    top: 20%;
    padding-right: 10%;
    padding-left: 10%;
    padding-top: 10%;
    box-sizing: border-box;
}
.left-section-form-logo
{
    color: rgb(198,50,9);
    font-weight: bolder;
}
.inner-textfield-link
{
    text-decoration: none;
    color: rgb(198,50,9);
    font-size: 11px;
    font-weight: bold;
}
</style>